import { COLOR_PALETTE } from 'constants/ui';

export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '16px',
  gap: '16px',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const headerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const titleStyles = {
  fontWeight: 600,
  color: ({ palette }) => palette.text.strong,
};

export const subtitleStyles = {
  color: ({ palette }) => palette.text.placeholder,
};

export const fieldGroupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const labelStyles = {
  fontWeight: 500,
  color: ({ palette }) => palette.text.secondary,
};

export const selectStyles = {
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
};

export const textFieldStyles = {
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
};

export const buttonRowStyles = {
  display: 'flex',
  gap: '8px',
  marginTop: 'auto',
};

export const saveButtonStyles = {
  flex: 1,
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 500,
  backgroundColor: COLOR_PALETTE.BRAND[6],
  '&:hover': {
    backgroundColor: COLOR_PALETTE.BRAND[7],
  },
};

export const skipButtonStyles = {
  flex: 1,
  borderRadius: '8px',
  textTransform: 'none',
  fontWeight: 500,
  color: ({ palette }) => palette.text.secondary,
  borderColor: ({ palette }) => palette.border.default,
};
